import React from 'react';
import { Link } from 'react-router-dom';

const PrimaryButtonLink = ({ to, variant = 'primary', children }) => {
  return (
    <Link to={to} className={`btn btn-${variant}`}>
      {children}
    </Link>
  );
};

export default PrimaryButtonLink;
